
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/form/radio-group/radio-group.component.js'
      import type { DdsChangeEvent } from '../../events/events'
import type { DdsBlurEvent } from '../../events/events'
import type { DdsFocusEvent } from '../../events/events'
      export type { DdsChangeEvent } from '../../events/events'
export type { DdsBlurEvent } from '../../events/events'
export type { DdsFocusEvent } from '../../events/events'

      const tagName = 'dap-ds-radio-group'

      /**
 * `dap-ds-radio-group`
 * @summary A radio group is a form element that allows the user to select one option from a set.
 * @element dap-ds-radio-group
 * @title - Radio group
 * @group radio-button
 *
 * @event dds-change - Fired when the radio group is checked.
 * @event dds-blur - Emitted when the radio group loses focus.
 * @event dds-focus - Emitted when the radio group gains focus.
 *
 * @property {string} name - The name of the radio group.
 * @property {string} value - The value of the radio group.
 * @property {boolean} disabled - Whether the radio group is disabled.
 * @property {boolean} required - Whether the radio group is required.
 * @property {string} label - The label of the radio group.
 * @property {string} description - The description of the radio group.
 * @property {string} tooltip - The tooltip of the radio group.
 * @property {'top' | 'right' | 'bottom' | 'left'} tooltipPlacement - The tooltip placement of the radio group.
 * @property {string} feedback - The feedback of the radio group.
 * @property {'negative' | 'positive' | 'warning'} feedbackType - The feedback type of the radio group. Can be `negative`, `positive`, or `warning`.
 * @property {boolean} optional - The optional state of the radio group.
 * @property {string} optionalLabel - Text of optional label.
 * @property {boolean} subtle - The weight of the label. Default is `false`
 * @property {'xs' | 'sm' | 'lg'} size - The size of the radio group. Default is `sm`.
 * @property {boolean} subtle - Font weight of the feedback label. Default is `false` which is bold.
 *
 * @slot - The content of the radio group.
 * @slot feedback-icon - The custom icon of the feedback.
 *
 * @csspart base - The main radio group container.
 * @csspart label - The label of the radio group.
 * @csspart tooltip - The tooltip of the radio group.
 * @csspart container - The container of the radio group items.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsChange: 'dds-change' as EventName<DdsChangeEvent>,
onDdsBlur: 'dds-blur' as EventName<DdsBlurEvent>,
onDdsFocus: 'dds-focus' as EventName<DdsFocusEvent>
        },
        displayName: "DapDSRadioGroup"
      })

      export default reactWrapper
    